var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-2"},[_c('v-btn',{attrs:{"color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.layout.run()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }